import { getUrlApi } from "../utilities/util";
import ApiHandler from "./ApiHandlers/ApiHandler";

export const baseURL = String(getUrlApi());

export default class ActionPlanApi {
  static async Create(actionPlanData: {
    failureId: string;
    name: string;
    description: string;
    type: string;
    status: string;
    forecastDate: Date;
    completionDate?: Date;
    responsibleSector: string;
    responsiblePerson: string;
  }): Promise<any> {
    const url = `/actionplans`;
    return ApiHandler(baseURL).post(url, actionPlanData);
  }

  static async UpdateActionPlanAsync(formData: FormData, id: string): Promise<any> {
    const response = await ApiHandler(baseURL).put(
      `/actionplans/${id}`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );
    return response.data;
  }

  static async DeleteActionPlanAsync(actionPlanId: string): Promise<any> {
    const url = `/actionplans/${encodeURIComponent(actionPlanId)}`;
    return ApiHandler(baseURL).delete(url);
  }

  static async GetByFilterAsync(
    pageNumber: number,
    pageSize: number,
    sortField: string,
    sortDirection: "asc" | "desc",
    name?: string,
    description?: string,
    type?: string,
    status?: string,
    operationName?: string,
    forecastDate?: string,
    responsibleSector?: string,
    responsiblePerson?: string,
    failureId?: string
  ): Promise<any> {
    let url = `/actionplans/filter?`;
    
    url += `pageNumber=${pageNumber}&pageSize=${pageSize}`;
    url += `&sortField=${encodeURIComponent(sortField)}`;
    url += `&sortDirection=${encodeURIComponent(sortDirection)}`;

    if (name) url += `&name=${encodeURIComponent(name)}`;
    if (description) url += `&description=${encodeURIComponent(description)}`;
    if (type) url += `&type=${encodeURIComponent(type)}`;
    if (status) url += `&status=${encodeURIComponent(status)}`;
    if (operationName) url += `&operationName=${encodeURIComponent(operationName)}`;
    if (forecastDate) url += `&forecastDate=${encodeURIComponent(forecastDate)}`;
    if (responsibleSector) url += `&responsibleSector=${encodeURIComponent(responsibleSector)}`;
    if (responsiblePerson) url += `&responsiblePerson=${encodeURIComponent(responsiblePerson)}`;
    if (failureId) url += `&failureId=${encodeURIComponent(failureId)}`;

    return ApiHandler(baseURL).get(url);
  }

  static async DeleteActionPlan(id: string): Promise<any> {
    const url = `/actionplans/${encodeURIComponent(id)}`;

    return ApiHandler(baseURL).delete(url);
  }

  static async GetByIdAsync(id: string): Promise<any> {
    const url = `/actionplans/${encodeURIComponent(id)}`;
    return ApiHandler(baseURL).get(url);
  }

  static async AddCommentAsync(actionPlanId: string, comment: string, createdBy: string): Promise<any> {
    const url = `/${encodeURIComponent(actionPlanId)}/comments`;
    return ApiHandler(baseURL).post(url, {
      actionPlanId,
      createdBy,
      comment
    });
  }

  static async GetCommentsAsync(actionPlanId: string): Promise<any> {
    const url = `/${encodeURIComponent(actionPlanId)}/comments`;
    return ApiHandler(baseURL).get(url);
  }
}
